var _path, _circle, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgServicesIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M17.3387 6.35305L16.82 5.45298C16.3812 4.69138 15.4087 4.42864 14.6461 4.86564V4.86564C14.283 5.07949 13.8499 5.14017 13.4421 5.03428C13.0342 4.92839 12.6853 4.66464 12.4722 4.30118C12.3351 4.07016 12.2614 3.80704 12.2586 3.53841V3.53841C12.271 3.10773 12.1085 2.69038 11.8081 2.38143C11.5078 2.07249 11.0952 1.89826 10.6644 1.89844H9.61938C9.19727 1.89843 8.79256 2.06664 8.4948 2.36583C8.19704 2.66502 8.03078 3.07053 8.0328 3.49264V3.49264C8.02029 4.36415 7.3102 5.06405 6.4386 5.06396C6.16997 5.06117 5.90684 4.98749 5.67583 4.85038V4.85038C4.91318 4.41339 3.94072 4.67612 3.50191 5.43772L2.94509 6.35305C2.5068 7.1137 2.76596 8.08555 3.5248 8.52697V8.52697C4.01805 8.81174 4.32191 9.33803 4.32191 9.90759C4.32191 10.4771 4.01805 11.0034 3.5248 11.2882V11.2882C2.76693 11.7267 2.50749 12.6961 2.94509 13.4545V13.4545L3.4714 14.3622C3.677 14.7332 4.02197 15.007 4.42996 15.1229C4.83795 15.2389 5.27533 15.1875 5.64531 14.9801V14.9801C6.00903 14.7678 6.44245 14.7097 6.84925 14.8185C7.25604 14.9274 7.60249 15.1942 7.8116 15.5598C7.94871 15.7908 8.02239 16.0539 8.02518 16.3225V16.3225C8.02518 17.203 8.73893 17.9167 9.61938 17.9167H10.6644C11.5419 17.9168 12.2544 17.2076 12.2586 16.3302V16.3302C12.2565 15.9067 12.4239 15.5001 12.7233 15.2006C13.0227 14.9012 13.4294 14.7339 13.8528 14.736C14.1208 14.7431 14.3828 14.8165 14.6156 14.9495V14.9495C15.3762 15.3878 16.3481 15.1287 16.7895 14.3698V14.3698L17.3387 13.4545C17.5513 13.0896 17.6096 12.655 17.5008 12.247C17.392 11.839 17.125 11.4912 16.759 11.2806V11.2806C16.3929 11.07 16.1259 10.7222 16.0171 10.3142C15.9083 9.90613 15.9667 9.47156 16.1793 9.10668C16.3175 8.86532 16.5176 8.66521 16.759 8.52697V8.52697C17.5133 8.08579 17.7718 7.11962 17.3387 6.36068V6.36068V6.35305Z",
    stroke: "url(#paint0_linear_1798_40839)",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 10.1455,
    cy: 9.90773,
    r: 2.1968,
    stroke: "url(#paint1_linear_1798_40839)",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint0_linear_1798_40839",
    x1: 10.1432,
    y1: 1.89844,
    x2: 10.1432,
    y2: 17.9167,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6CDA60"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#45BF38"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "paint1_linear_1798_40839",
    x1: 10.1455,
    y1: 7.71094,
    x2: 10.1455,
    y2: 12.1045,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    stopColor: "#6CDA60"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 1,
    stopColor: "#45BF38"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgServicesIcon);
export default __webpack_public_path__ + "static/media/services-icon.27beac4d2c75e710662a53762e314f04.svg";
export { ForwardRef as ReactComponent };